import Container from '../ui/Container';
import { clientLogos } from '../../data/site';

/**
 * Infinite marquee of client wordmarks. The list is duplicated so the
 * -50% translate loops seamlessly.
 */
export default function TrustBar() {
  return (
    <section className="border-y border-ink-100 bg-white py-10">
      <Container>
        <p className="text-center text-xs font-semibold uppercase tracking-[0.18em] text-ink-400">
          Trusted by compliance and IT teams at
        </p>
      </Container>

      <div className="relative mt-7 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_12%,#000_88%,transparent)]">
        <div className="flex w-max animate-marquee gap-14 hover:[animation-play-state:paused]">
          {[...clientLogos, ...clientLogos].map((logo, index) => (
            <span
              key={`${logo}-${index}`}
              aria-hidden={index >= clientLogos.length}
              className="whitespace-nowrap font-display text-base font-bold tracking-[0.12em] text-ink-300 transition-colors duration-300 hover:text-brand-600 sm:text-lg"
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
